import request from '@/utils/request'

export function getSawonList(params) {
    return request({
        url: '/v2/sec/Sawon/getSawonList',
        method: 'post',
        data: params
    })
}

export function setSawonDel(params) {
    return request({
        url: '/v2/sec/Sawon/setSawonDel',
        method: 'post',
        data: params
    })
}

export function setSawonPersonInsert (params) {
    return request({
      url: '/v2/sec/Sawon/setSawonPersonInsert',
      method: 'post',
      data: params
    })
}

export function setSawonExcelInsert (params) {
    return request({
      url: '/v2/sec/Sawon/setSawonExcelInsert',
      method: 'post',
      data: params
    })
}

export function setSawonList (params) {
    return request({
      url: '/v2/sec/Sawon/setSawonList',
      method: 'post',
      data: params
    })
}